// Nur Parse-Basis fuer relative Pfade, kein echter Host: Ziel ist immer
// ein Pfad auf der eigenen Instanz (HUB_PUBLIC_URL), absolute URLs werden
// abgelehnt. Die reservierte Domain .invalid kann nie aufgeloest werden.
const INTERNAL_ORIGIN = 'https://hub.invalid'
const SAFE_LAUNCH_PATH = /^\/launch\/[a-z0-9-]+$/

export function safeLaunchReturnTo(value: string | null | undefined): string | null {
  if (!value || value.length > 200 || value.startsWith('//')) return null
  try {
    const target = new URL(value, INTERNAL_ORIGIN)
    if (target.origin !== INTERNAL_ORIGIN || !SAFE_LAUNCH_PATH.test(target.pathname)) return null
    return `${target.pathname}${target.search}`
  } catch {
    return null
  }
}
